module.exports = "<span class=\"ssf-showHide\">\n    <span *ngIf=\"shown\">\n        {{ i18n + 'HIDE' | translate }}\n        <i class=\"fa fa-chevron-up\"></i>\n    </span>\n    <span *ngIf=\"!shown\">\n        {{ i18n + 'SHOW-DETAIL' | translate }}\n        <i class=\"fa fa-chevron-down\"></i>\n    </span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/details-button/details-button.component.html
// module id = 651
// module chunks = 3